import SubscriptionPlan from "../components/SubscriptionPlan/SubscriptionPlan";

export default function Prices(){
    return(
        <SubscriptionPlan/>
    )
}